document.addEventListener("DOMContentLoaded", function () {
  let collectionSwipers = document.querySelectorAll(".collection-swiper");

  if (collectionSwipers.length > 0) {
    collectionSwipers.forEach((collectionSwiper) => {
      new Swiper(collectionSwiper, {
        loop: true,
        slidesPerView: 2.25,
        spaceBetween: 12,
        draggable: true,
        freeMode: true,
        mousewheel: {
          forceToAxis: true,
        },
        wrapperClass: "collection-wrapper",
        slideClass: "collection-slide",

        navigation: {
          nextEl: ".arrows .right",
          prevEl: ".arrows .left",
        },
        breakpoints: {
          600: {
            slidesPerView: 3,
            spaceBetween: 12,
          },
          880: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
          1280: {
            slidesPerView: 6,
            spaceBetween: 24,
          },
        },
        on: {
          init: function () {
            // Add class to all slides inside this Swiper instance
            this.slides.forEach((slide) => {
              slide.classList.add("finished-loading");
            });
          },
        },
      });
    });
  }
});
